import React from 'react';
const voices = [{
  quote: 'Vera opened my eyes to what was still possible in my 50s. They steered me around injuries, and I show up to skiing and golf the way I used to. It changed how I move through the rest of my life.',
  name: 'Jaret W.',
  detail: 'Executive'
}, {
  quote: 'My workouts are non-negotiable because I want to do them. I have more energy, more clarity, and a lot more self-trust when it comes to my body and my health.',
  name: 'Disha S.',
  detail: 'Founder'
}, {
  quote: 'I have so much more energy and I’m able to show up for my kids as a healthy active role model.',
  name: 'Megan P.',
  detail: 'Chiropractor'
}];
export function SelectedVoices() {
  return <section className="px-6 md:px-12 lg:px-20 max-w-[88rem] mx-auto py-28 md:py-32 border-t border-ink/10" data-id="element-64" data-mp="2fwi5jfzpncfk">
      <div className="label text-graphite/60 mb-20" data-id="element-65" data-mp="8rweji7yzmz">Selected Voices</div>
      <div className="flex flex-col gap-20 md:gap-24" data-id="element-66" data-mp="3rc6x6knwszmp">
        {voices.map((voice, i) => <figure key={voice.name} className={i % 2 === 0 ? 'max-w-2xl' : 'max-w-2xl md:ml-auto md:text-right'} data-id="element-67" data-mp="1fpg0sk2wk39c" data-mpi={i}>
            <blockquote className="font-serif italic text-xl md:text-2xl text-ink/85 leading-relaxed" data-id="element-68" data-mp="1po5lekm6o1ta">
              {'“' + voice.quote + '”'}
            </blockquote>
            <figcaption className="label text-graphite/50 mt-6" data-id="element-69" data-mp="wzrmm2n9t1go">
              {voice.name + ' · ' + voice.detail}
            </figcaption>
          </figure>)}
      </div>
    </section>;
}